import {EnvNoticePutDataTransferObject} from "../../data-transfer-object/env/EnvNoticePutDataTransferObject"

/**
 * 공지사항 속성 설명
 */
export const EnvNoticePutDataTransferObjectDescription: Record<keyof EnvNoticePutDataTransferObject, string> = {
    title: '제목',
    url: 'URL'
}
